import React from "react";
import End from "./utils/End";
import Introduction from "./utils/Introduction";
import Mission2 from "./utils/Mission2";
import Mission3 from "./utils/Mission3";

export function RecipeApp(props) {
  return (
    <div className="challenge-details container">
      <Introduction track="Software Engineer" logo={props.logo} />
      <h2 className="mission-1">
        Mission 1: Create a <strong>Recipe App</strong>
      </h2>
      <h3>Description</h3>
      <ul>
        <li>
          An application where users can maintain their recipes. It should
          contain at least 2 pages:
          <br />
          <ul>
            <li>
              {" "}
              Where you can add new recipe(recipe title, list of ingredients,
              preparation steps)
            </li>
            <li>Where you see a list of recipe titles</li>
          </ul>
        </li>
        <li>
         You should have a separate backend for handling the storage
        </li>
      </ul>
      <h3>Rules</h3>
      <ul>
        <li>Write your solution in the language and framework you want</li>
        <li>You may use packages</li>
      </ul>
      <Mission2 track="SE Engineer" />
      <Mission3 notes="you can  write some notes to us. These notes can be anything you would like us to know, especially for technical decisions. They are not mandatory, so you can also skip this this parameter." />
      <End />
    </div>
  );
}
